import * as React from "react";
import { credentials } from "src/models/general-models";
import { ContactModel } from "src/models/contact-models";
import { getString } from "src/server/graphDB-utils";
import { authenticateUserForApp } from "src/server/utils/contact-utils";
import { showHideLoadingDiv } from "src/loaders/StyleLoader";
import StorageUtils from "src/server/utils/storage-utils";
import { redirectBackToApp } from "src/server/utils/general-utils";

interface Props {
    instance: string;
    user: string;
    password: string;
}

interface State {
    Credentials: credentials;
}

class LoginFromApp extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Credentials: { password: "", username: "" }
        }
        this.authenticate = this.authenticate.bind(this);
    }

    async componentDidMount() {
        const { Credentials } = this.state;
        StorageUtils.clear();
        Credentials.username = this.props.user;
        Credentials.password = this.props.password;
        this.setState({
            Credentials
        }, () => {
            this.authenticate();
        })
    }

    async authenticate() {
        showHideLoadingDiv(true);
        let user: ContactModel = Object();
        let Credentials = this.state.Credentials;
        await authenticateUserForApp(Credentials).then((contacts) => {
            if (contacts && contacts.length > 0) {
                const contact = contacts[0];
                if (getString(contact.contact)) {
                    user.contact = getString(contact.contact);
                    user.name = getString(contact.name);
                    user.mobile = getString(contact.phone);
                    user.email = getString(contact.email);
                    user.group = getString(contact.group);
                    user.role = getString(contact.role);
                    user.facility = getString(contact.assignedTo);
                    user.smsSchedule = getString(contact.smsSchedule);
                    user.stripePaymentMethodId = getString(contact.stripePaymentMethodId);
                    user.stripeCustomerId = getString(contact.stripeCustomerId);
                    user.stripeSubscriptionId = getString(contact.stripeSubscriptionId);
                    user.company = getString(contact.company);
                    user.streetAddress = getString(contact.street);
                    user.city = getString(contact.city);
                    user.state = getString(contact.state);
                    user.zipcode = getString(contact.zipcode);
                    user.notes = getString(contact.notes);
                    user.loginTime = new Date().toString();
                    const data = getString(contact.qualifications).split(",")
                    let qualifications = [];
                    for (let i = 0; i < data.length; i++) {
                        qualifications[i] = data[i]
                    }
                    user.qualifications = qualifications;
                    const depts = getString(contact.departmentsAndGroups) && getString(contact.departmentsAndGroups).split(",");
                    if (depts && depts.length) {
                        user.departmentsAndGroups = depts.map(x => { return { label: x, value: x } });
                    }
                    // user.signatureDataURL = getString(contact.signatureDataURL);

                    StorageUtils.setItem('user', JSON.stringify(user));
                    StorageUtils.setItem('token', contact.token);
                    StorageUtils.setItem('verifyOTP', '0');
                    redirectBackToApp(this.props.instance + '/bXut/Tasks');

                    // window.location.hash="/Buildings";
                    // ................uncomment this line after login work........................
                    //window.location.reload();
                }
                else {
                }
            }
            else {
            }
            showHideLoadingDiv(false);
        }).catch((reason: any) => {
            showHideLoadingDiv(false);
        });
    }

    render() {

        return (
            <>
            </>
        )
    }
}

export default LoginFromApp;



// WEBPACK FOOTER //
// ./src/Components/People/LoginFromApp.tsx